import React, { Component } from 'react';
// import { withTranslation } from 'react-i18next'
import { Form, Input, Button, Checkbox, Icon } from 'antd';
import lock from '../../Images/Icons/lock.svg';
import user from '../../Images/Icons/user.svg';
import hide from '../../Images/Icons/hide.svg';
import show from '../../Images/Icons/show.svg';
// import dropdown from '../../Images/Icons/dropdown.svg';
import './Login.css';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // selectedLanguage: props.dropdownContent[0],
      passwordHidden: true,
      username: '',
      password: '',
      // langDropdownVisible: false
    };
  }

  // componentWillReceiveProps(nextProps) {
  // 	const { dropdownContent } = this.props
  // 	const storedLanguage = localStorage.getItem('language')
  // 	if (JSON.stringify(dropdownContent) !== JSON.stringify(nextProps.dropdownContent)) {
  // 		this.setState({
  // 			selectedLanguage: storedLanguage ?
  // 				nextProps.dropdownContent.filter(item => item.languageCode === storedLanguage)[0] :
  // 				nextProps.dropdownContent[0]
  // 		})
  // 		this.props.i18n.changeLanguage(storedLanguage || 'en_IN');
  // 	}
  // }

  handleSubmit = (e) => {
    e.preventDefault();
    const { getFieldsValue } = this.props.form;
    if (!getFieldsValue().password || !getFieldsValue().username) {
      this.setState({
        username: !getFieldsValue().username,
        password: !getFieldsValue().password,
      });
      return;
    }

    this.props.form.validateFields((err, values) => {
      if (!err) {
        values = {
          ...values,
          // languageId: this.state.selectedLanguage.languageUuid
        };
        this.props.loginData(values);
      }
    });
  };

  languageSelect = (language) => {
    this.setState(
      {
        selectedLanguage: language,
        langDropdownVisible: false,
      },
      () => {
        this.props.i18n.changeLanguage(language.languageCode);
        localStorage.setItem('language', language.languageCode);
      }
    );
  };

  checkRequiredField = (value, field) => {
    if (value.trim() === '') {
      this.setState({
        [field]: true,
      });
    } else {
      this.setState({
        [field]: '',
      });
    }
  };

  togglePassword = (e) => {
    this.setState({
      passwordHidden: !this.state.passwordHidden,
    });
  };

  render() {
    // const { t, i18n, dropdownContent } = this.props;
    const { getFieldDecorator } = this.props.form;
    const {
      selectedLanguage,
      passwordHidden,
      username,
      password,
      langDropdownVisible,
    } = this.state;
    // const menu = (
    // 	<Menu className="loginLangDropdownContainer">
    // 		{dropdownContent.map((item, index) => (
    // 			<div style={{cursor: index !== 0 && 'not-allowed'}}>
    // 				<span key={index} className={index !== 0 && "disableLoginLanguage"}
    // 				onClick={() => {
    // 					i18n.changeLanguage(item.languageCode)
    // 					this.languageSelect(item)
    // 				}}>
    // 					{item.languageFlag ?
    // 						<img style={{ width: "20px", marginRight: "10px" }} src={item.languageFlag} className="flagIcon" /> :
    // 						<Icon component={item.icon} />
    // 					}
    // 					{item.languageNativeCode}
    // 				</span>
    // 			</div>
    // 		))}
    // 	</Menu>
    // );
    return (
      <div className="loginformWrapper">
        <Form
          onSubmit={this.handleSubmit}
          style={{
            width: '100%',
          }}
        >
          <div className="loginHeaderContainer">Login</div>
          {/* <Form.Item className="loginLanguageDropdownField loginFormField">
						<span className="loginLabel">{t('Select language')}</span>
						{getFieldDecorator('language')
							(<Dropdown overlay={menu} trigger={['click']} visible={langDropdownVisible}
								onVisibleChange={(visible) => {
									this.setState({
										langDropdownVisible: visible
									})
								}}
								className="loginLanguageDropdown">
								<span>
									<span className="loginLangIconContainer" >
										{selectedLanguage && selectedLanguage.languageFlag ?
											<img style={{ width: "100%" }} src={selectedLanguage.languageFlag} className="flagIcon" /> :
											<Icon component={selectedLanguage && selectedLanguage.icon} />
										}
									</span>
									{selectedLanguage && selectedLanguage.languageNativeCode}
									<Icon className="loginLangDropdownIcon" component={() => <img src={dropdown} style={{ height: '10px', width: '10px' }} />} />
								</span>
							</Dropdown>)
						}
					</Form.Item> */}
          <Form.Item className="loginFormField">
            <span className="loginLabel">Username</span>
            {getFieldDecorator('username')(
              <Input
                autoComplete="off"
                prefix={
                  <Icon
                    component={() => (
                      <img src={user} className="loginLockIcon" />
                    )}
                  />
                }
                onChange={(e) =>
                  this.checkRequiredField(e.target.value, 'username')
                }
                placeholder="Enter username"
              />
            )}
            {username && (
              <span className="loginEmptyError">
                Please input your username
              </span>
            )}
          </Form.Item>
          <Form.Item className="loginFormField">
            <span className="loginLabel">Password</span>
            {getFieldDecorator('password')(
              <Input
                type={passwordHidden ? 'password' : 'text'}
                prefix={
                  <Icon
                    component={() => (
                      <img src={lock} className="loginLockIcon" />
                    )}
                  />
                }
                placeholder="Enter password"
                onChange={(e) =>
                  this.checkRequiredField(e.target.value, 'password')
                }
                suffix={
                  <Icon
                    component={() => (
                      <img
                        src={passwordHidden ? hide : show}
                        style={{
                          height: '16px',
                          cursor: 'pointer',
                        }}
                        onClick={(e) => this.togglePassword(e)}
                      />
                    )}
                  />
                }
              />
            )}
            {password && (
              <span className="loginEmptyError">
                Please input your password
              </span>
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: false,
            })(
              <span className="rememberMeCheck">
                <Checkbox>Remember me</Checkbox>
              </span>
            )}
            {/* <a className="forgotPassword" onClick={() => this.props.forgotPassword()}>
							Forgot password?
						</a> */}
          </Form.Item>
          <Button type="primary" htmlType="submit" className="loginButton">
            Log in
          </Button>
        </Form>
      </div>
    );
  }
}
export default LoginForm;
